import { DateString } from "@pentacode/openapi";
import { Type } from "class-transformer";
import { DTOConstructor } from "./dto-constructor";

import { TimeEntryType } from "../../time-entries/time-entry-type";
import { PositionDTO } from "./position";

export class TimeEntryPublishedInfoDTO extends DTOConstructor<TimeEntryPublishedInfoDTO> {
    @Type(() => Date)
    time: Date;
    @Type(() => Date)
    deleted: Date | null;
    employeeId: number | null;
    date: DateString;
    positionId: number | null;

    @Type(() => Date)
    startPlanned: Date | null;
    @Type(() => Date)
    endPlanned: Date | null;
    comment?: string;
}

export class PublishedRosterEmployeeDTO extends DTOConstructor<PublishedRosterEmployeeDTO> {
    id: number;
    name: string;
    positions: PositionDTO[];
}

export class PublishedRosterDepartmentDTO extends DTOConstructor<PublishedRosterDepartmentDTO> {
    id: number;
    name: string;
    color: string;
    order: number;
    rosterOrder: string[];
    archived: boolean;
}

export class PublishedRosterVenueDTO extends DTOConstructor<PublishedRosterVenueDTO> {
    id: number;
    name: string;
    enabledHolidays: string[];
    departments: PublishedRosterDepartmentDTO[];
}

export class PublishedRosterTimeEntryDTO extends DTOConstructor<PublishedRosterTimeEntryDTO> {
    @Type(() => Date)
    start: Date;

    @Type(() => Date)
    startPlanned: Date | null;

    @Type(() => Date)
    endPlanned: Date | null;

    @Type(() => Date)
    deleted: Date | null;

    date: DateString;

    isPast: boolean;
    published: TimeEntryPublishedInfoDTO | null;
    position: PositionDTO | null;
    type: TimeEntryType;
    employeeId: number | null;
}

export class PublishedRosterDTO extends DTOConstructor<PublishedRosterDTO> {
    //this is nested for backwards-compatibility reasons
    roster: {
        venue: PublishedRosterVenueDTO;
        from: DateString;
        to: DateString;
    };

    @Type(() => PublishedRosterTimeEntryDTO)
    timeEntries: PublishedRosterTimeEntryDTO[];

    @Type(() => PublishedRosterEmployeeDTO)
    employees: PublishedRosterEmployeeDTO[];
}
